import { Component, EventEmitter, Input, Output } from '@angular/core';

// Reusable confirmation modal.
@Component({
  selector: 'app-confirm-modal',
  templateUrl: './confirm-modal.component.html',
  styleUrls: ['./confirm-modal.component.scss']
})
export class ConfirmModalComponent {
  // Visibility.
  @Input() visible = false;
  // Title.
  @Input() title = 'Confirm action';
  // Message.
  @Input() message = 'Are you sure?';
  // Confirm output.
  @Output() confirm = new EventEmitter<void>();
  // Cancel output.
  @Output() cancel = new EventEmitter<void>();
}
